export function mapDataToGraphData(allData, start_year, end_year) {

    let plotData = [];
    let categoryList = [];
    let keyIndex = 0;

    for (let category in allData) {
        // Append to plotData

        let xDataYears = [];
        let value = parseInt(start_year);
        while (value !== parseInt(end_year)) {
            xDataYears.push(value);
            value = value + 1;
        }

        let yValues = [];
        Object.keys(allData[category])
            .sort(((a, b) => (parseFloat(a) - parseFloat(b))))
            .forEach(value1 => {
                yValues.push(allData[category][value1].toFixed(0));
            });

        const dataset = {
            x: xDataYears.sort((a, b) => {
                return a - b
            }),
            y: yValues,
            name: category,
            mode: 'lines+markers',
            type: 'scatter'
        };
        plotData.push(dataset);

        // Append to target_categories
        const listItem = {
            key: keyIndex,
            name: category
        };
        categoryList.push(listItem);
        keyIndex++;
    }

    return {plotData, categoryList}
}
